/**
 * Curated subset of Lucide icons for schema icon selection.
 * Organized by semantic category. Each entry is a kebab-case
 * icon name matching lucide-react component names.
 */

export const CURATED_ICON_CATEGORIES = [
  {
    label: 'People',
    icons: [
      'user', 'users', 'user-check', 'user-plus', 'contact',
      'baby', 'brain', 'heart', 'fingerprint', 'hand-heart',
    ],
  },
  {
    label: 'Places',
    icons: [
      'building', 'building-2', 'home', 'map-pin', 'globe',
      'landmark', 'mountain', 'map', 'compass', 'flag',
    ],
  },
  {
    label: 'Business',
    icons: [
      'briefcase', 'calculator', 'presentation', 'handshake',
      'id-card', 'receipt', 'wallet', 'scale', 'gavel', 'stamp',
    ],
  },
  {
    label: 'Education',
    icons: [
      'graduation-cap', 'book-open', 'library', 'school',
      'notebook', 'pencil', 'ruler', 'atom', 'flask-conical', 'microscope',
    ],
  },
  {
    label: 'Health',
    icons: [
      'heart-pulse', 'stethoscope', 'pill', 'syringe',
      'activity', 'dumbbell', 'apple', 'bed', 'thermometer', 'eye',
    ],
  },
  {
    label: 'Tech',
    icons: [
      'laptop', 'smartphone', 'server', 'database', 'cpu',
      'wifi', 'code', 'terminal', 'cloud', 'hard-drive',
      'monitor', 'keyboard', 'mouse', 'printer', 'cable',
    ],
  },
  {
    label: 'Media',
    icons: [
      'image', 'camera', 'video', 'music', 'mic',
      'film', 'headphones', 'tv', 'radio', 'newspaper',
    ],
  },
  {
    label: 'Comms',
    icons: [
      'mail', 'message-circle', 'phone', 'megaphone',
      'at-sign', 'send', 'rss', 'bell', 'inbox', 'message-square',
    ],
  },
  {
    label: 'Finance',
    icons: [
      'credit-card', 'banknote', 'coins', 'piggy-bank',
      'shopping-cart', 'store', 'trending-up', 'bar-chart-3',
      'pie-chart', 'badge-dollar-sign',
    ],
  },
  {
    label: 'Travel',
    icons: [
      'car', 'plane', 'train-front', 'ship', 'bike',
      'fuel', 'navigation', 'luggage', 'ticket', 'route',
    ],
  },
  {
    label: 'Nature',
    icons: [
      'leaf', 'flower', 'sun', 'moon', 'cloud-sun',
      'droplets', 'wind', 'snowflake', 'sprout', 'trees',
    ],
  },
  {
    label: 'Objects',
    icons: [
      'package', 'gift', 'key', 'lock', 'wrench',
      'scissors', 'lightbulb', 'battery', 'clock', 'calendar',
      'bookmark', 'star', 'award', 'trophy', 'target',
      'gem', 'crown', 'shield', 'zap', 'flame',
    ],
  },
];
